/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {DirtyWildsGameConfig} from "./DirtyWildsGameConfig";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {DirtyWildsSymbols} from "./symbols/DirtyWildsStateReelSymbol";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";


export class DirtyWildsGameAssets {
    static INTRO_LOGO:string = "logo";
    static INTRO_BACKGROUND:string = "IntroBackground";
    static MAYAN_MYSTERY:string = "MayanMystery";
    static MAYAN_WILD:string = "MayanWilds";
    public static NORMAL_REEL_DIVIDER:string = "ui/reelDividers/div";
    public static NEAR_WIN_REEL_DIVIDER:string = "ui/reelDividers/div-attention";


    static MULTIPLIER_FRAME_TRANSFORM:string = "wildTransform";
    static WILD_FRAME_ACTIVATION:string = "activateFrame";


    static TOP_BAR_FIRE_UPDATE:string = "top_bar_fire_update";
    static TOP_BAR_FROM_CENTER_FIRE:string = "top_bar_from_center_fire";
    static TOP_BAR_BEHIND_TEXT_FIRE:string = "top_bar_behind_text_fire";


    static NEAR_WIN_REEL_HIGHLIGHT:string = "nearWin/attentionFx";


    static MULTIPLIER_PARTICLE_1:string = "particles/multiplierParticle1";

    static WIN_DISPLAY_PARTICLE_1:string = "particles/coin1";
    static WIN_DISPLAY_PARTICLE_2:string = "particles/coin2";
    static WIN_DISPLAY_PARTICLE_3:string = "particles/coin3";
    static WIN_DISPLAY_PARTICLE_4:string = "particles/coin4";

    static BIG_WIN_PARTICLE_1:string = "particles/bigWinParticle";

    static MIST_PARTICLE:string = "environment/cloud";

    static WILD_ATTENTION_EXPLOSION:string = "wild_attention_explosion";

    static FIRE_PARTICLES:string = "fire_particles";

    static TOP_BAR_FIRE_LEFT:string = "topbar/fireLeft";
    static TOP_BAR_FIRE_RIGHT:string = "topbar/fireRight";

    static RESPIN_INTRO_FIREBALL:string = "respin_intro_fireball";
    static RESPIN_INTRO_FIRE_PARTICLE:string = "particles/fireParticle";


    static GENERIC_SYMBOL_WIN_SPINE:string = "generic_symbol_win_spine";
    static FIREBALL_TRAIL_SPINE:string = "fireball_trail_spine";

    static WILD_SYMBOL_SPINE:string = "wild_symbol_spine";
    static MULTIPLIER_FIRE_SQUARE:string = "multiplier_fire_square";
    static REEL_ATTENTION:string = "reel_attention";
    static TOP_BAR_LOGO:string = "top_bar_logo";
    static ENV_BACK_SPINE:string = "env_back_spine";
    static ENV_FRONT_SPINE:string = "env_front_spine";
    static ENV_MIDDLE_SPINE:string = "env_middle_spine";
    static ENV_TEMPLE_SPINE:string = "env_temple_spine";
    static ENV_WATER_SPINE:string = "env_water_spine";
    static BACK_DARKENING_SPINE:string = "back_darkening_spine";
    static WIN_BET_LINES:string = "win_bet_line_spine";

    static TEMPLE_EFFECTS:string = "temple_effects";
    static MYSTERY_SPINE:string = "mystery_spine";

    static TOP_BAR_NUMBER_FIRE:string = "top_bar_number_fire";
    static TOP_BAR_NUMBER:string = "top_bar_number";

    static TOP_BAR_SPINS_LEFT_SPINE:string = "top_bar_spins_left_spine";

    static BIG_WIN_SPINE:string = "big_win_spine";
    static LIGHT_PULSE:string = "bigwin/lightPulse";


    static getNearWinDividerTextures(index:number):PIXI.Texture[] {
        return GameResources.getTextures(DirtyWildsGameAssets.NEAR_WIN_REEL_HIGHLIGHT);
    }

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        if(symbolName == DirtyWildsSymbols.NONE) {
            return [PIXI.Texture.EMPTY];
        }

        if(symbolName == DirtyWildsSymbols.W) {
            if(stateName == DirtyWildsGameConfig.instance.SYMBOL_STATES.spin.keyword) {
                return GameResources.getTextures(DirtyWildsGameAssets.getSymbolStateTexturePath(symbolName, stateName));
            }
            return [PIXI.Texture.EMPTY];
        }

        if(stateName == DirtyWildsGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            return GameResources.getTextures(DirtyWildsGameAssets.getSymbolStateTexturePath(symbolName, stateName));
        }

        return GameResources.getTextures(DirtyWildsGameAssets.getSymbolStateTexturePath(symbolName));
    }

    public static getSymbolStateScale(symbolName:string, stateName:string | null = null):[number, number] {
        //return [0.9,0.9];
        return [1, 1];
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("multiplierNumbers", "fonts/bitmapfonts/multiplierNumbers.fnt"),
                    new BitmapFontAsset("firespinNumbers", "fonts/bitmapfonts/firespinNumbers.fnt"),
                    new BitmapFontAsset("winCountUpNumbersWhite", "fonts/bitmapfonts/winCountUpNumbersWhite.fnt"),
                    new BitmapFontAsset("winCountUpNumbers", "fonts/bitmapfonts/winCountUpNumbers.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ]
            },
            {
                name : "introJpeg",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json"),
                ]
            }
        ],
        main : [
            {
                name : "spine",
                assets : [
                    new SpineAsset(DirtyWildsGameAssets.ENV_BACK_SPINE, "spine/environment/EnvBack.json"),
                    new SpineAsset(DirtyWildsGameAssets.ENV_MIDDLE_SPINE, "spine/environment/EnvMiddle.json"),
                    new SpineAsset(DirtyWildsGameAssets.ENV_TEMPLE_SPINE, "spine/environment/EnvTemple.json"),
                    new SpineAsset(DirtyWildsGameAssets.ENV_WATER_SPINE, "spine/environment/EnvWater.json"),
                    new SpineAsset(DirtyWildsGameAssets.REEL_ATTENTION, "spine/environment/ReelAttention.json"),
                    new SpineAsset(DirtyWildsGameAssets.BACK_DARKENING_SPINE, "spine/environment/backDarkening.json"),
                    new SpineAsset(DirtyWildsGameAssets.ENV_FRONT_SPINE, "spine/environment/EnvFront.json"),


                    new SpineAsset(DirtyWildsGameAssets.MYSTERY_SPINE, "spine/MysteryFeature.json"),

                    new SpineAsset(DirtyWildsGameAssets.TOP_BAR_NUMBER_FIRE, "spine/TopBarNumberFire.json"),
                    new SpineAsset(DirtyWildsGameAssets.MULTIPLIER_FIRE_SQUARE, "spine/MultiplierFireSquare.json"),
                    new SpineAsset(DirtyWildsGameAssets.TOP_BAR_NUMBER, "spine/TopBarNumbers.json"),

                    new SpineAsset(DirtyWildsGameAssets.BIG_WIN_SPINE, "spine/BigWin.json"),

                    new SpineAsset(DirtyWildsGameAssets.FIREBALL_TRAIL_SPINE, "spine/FireballTrail.json"),
                    new SpineAsset(DirtyWildsGameAssets.GENERIC_SYMBOL_WIN_SPINE, "spine/GenericSymbolWin.json"),
                    new SpineAsset(DirtyWildsGameAssets.WILD_SYMBOL_SPINE, "spine/WildSymbolSpine.json")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json")

                ],
                animations : {
                    [DirtyWildsGameAssets.MULTIPLIER_FRAME_TRANSFORM] : "multiplier/transform/wildTransform_",
                    [DirtyWildsGameAssets.WILD_FRAME_ACTIVATION] : "multiplier/activateFrame/activateFrame_",
                    [DirtyWildsGameAssets.TOP_BAR_FIRE_UPDATE] : "topbar/fireUpdateAnimation/fireUpdate_0",
                    [DirtyWildsGameAssets.TOP_BAR_FROM_CENTER_FIRE] : "topbar/fromCenterFire/fromCenterFire_0",
                    [DirtyWildsGameAssets.TOP_BAR_BEHIND_TEXT_FIRE] : "topbar/behindTextFire/behindTextFire_0",
                    [DirtyWildsGameAssets.RESPIN_INTRO_FIREBALL] : "respinIntro/fireball/fireball_0"
                }
            },
            {
                name : "mainHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json")
                ],
                animations : {
                    [DirtyWildsGameAssets.FIRE_PARTICLES] : "particles/fireToon/fireParticle_0"
                }
            },
            {
                name : "mainWaterfall",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainWaterfall0", "sheets/mainWaterfall/mainWaterfall0.json"),
                    new TextureAsset("mainWaterfall1", "sheets/mainWaterfall/mainWaterfall1.json")
                ]
            },
            {
                name : "environment",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("environment0", "sheets/environment/environment0.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations : {
                    "WSticky/WSticky_idle" : "WSticky/WSticky_idle/WSticky_idle_0",
                    [DirtyWildsGameAssets.WILD_ATTENTION_EXPLOSION] : "W/W_attention/W_attention_0",

                }
            }
        ]
    };


}